import React from "react";
import { motion } from "framer-motion";
import { HOW_IT_WORKS_STEPS } from "../data/howItWorksSteps";

const ease = [0.21, 0.47, 0.32, 0.98];

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

const StepCard = ({ step, index }) => (
  <div
    data-testid={`step-${index}`}
    className="text-center md:text-left flex flex-col items-center md:items-start"
  >
    <div
      className="w-24 h-24 rounded-[1.75rem] flex items-center justify-center mb-7 cozy-card shrink-0"
      style={{ background: "var(--surface)" }}
    >
      <span
        className="font-serif text-4xl italic font-medium"
        style={{ color: "var(--brand)" }}
      >
        {step.n}
      </span>
    </div>
    <h3
      className="font-serif text-2xl md:text-3xl font-medium mb-3"
      style={{ color: "var(--text)" }}
    >
      {step.title}
    </h3>
    <p
      className="text-base leading-relaxed max-w-xs"
      style={{ color: "var(--text-soft)" }}
    >
      {step.desc}
    </p>
  </div>
);

const HowItWorksSteps = ({ className = "" }) => (
  <div className={className} data-testid="how-it-works-steps">
    <div className="grid gap-12 md:hidden">
      {HOW_IT_WORKS_STEPS.map((step, i) => (
        <Reveal key={step.n} delay={i * 0.12}>
          <StepCard step={step} index={i} />
        </Reveal>
      ))}
    </div>

    <div className="hidden md:flex items-start w-full">
      {HOW_IT_WORKS_STEPS.map((step, i) => (
        <React.Fragment key={step.n}>
          <Reveal delay={i * 0.12} className="flex-1 min-w-0">
            <StepCard step={step} index={i} />
          </Reveal>
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default HowItWorksSteps;
